module.exports = __webpack_public_path__ + "media/images/players/JOHNSON_DUSTIN-7e37c6943287df9f96727896a67a9715.png";